import React, { Fragment, useContext, useEffect, useRef, useState } from 'react'
import { Badge, Box, Button, Drawer, FormControl, IconButton, InputLabel, LinearProgress, MenuItem, Select, Skeleton, Switch, Tab, Tabs, TextField, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import PropTypes, { number } from 'prop-types';
import { styled } from '@mui/material/styles';
import { GetSubTasks } from '../api/GetSubTasks.api';
import { UpdateSubTask } from '../api/UpdateSubTask.api';
import { IMaskInput } from 'react-imask';
import { DrawerRegistros } from './DrawerRegistros.component';
import LoginContext from '../context/login_context/LoginContext';
import { CreaSolicitud } from '../api/CreaSolicitud.api';
import { GetUserFracttal } from '../api/GetUserFracttal.api';
import { GetResourceOT } from '../api/GetResourceOT.api';
import { AddResouceH } from '../api/AddResouceH.api';
import { DeleteResouceH } from '../api/DeleteResouceH.api';
import './main.css'

/** icons */
import VisibilityIcon from '@mui/icons-material/Visibility';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import AttachmentIcon from '@mui/icons-material/Attachment';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import SaveIcon from '@mui/icons-material/Save';
import { FaListCheck } from "react-icons/fa6";
import { GoTools } from "react-icons/go";
import { GoPaperclip } from "react-icons/go";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import DeleteIcon from '@mui/icons-material/Delete';
import AddPhotoAlternateOutlinedIcon from '@mui/icons-material/AddPhotoAlternateOutlined';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { cleanDigitSectionValue } from '@mui/x-date-pickers/internals/hooks/useField/useField.utils';
import { UploadFile } from '../api/UploadFile.api';
import { ViewDrawerRegistros } from './ViewRegistros.component';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { URL_SRV_RAIZ } from '../router/Url';
import { AddRegistro } from '../api/AddRegistro.api';
import { StatusToRevcn } from '../api/StatusToRevcn.api';
import { BkpRRHH_fracttal } from '../api/OT/BkpRRHH_fracttal.api';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

// console.log(Math.floor((new Date).getTime()/1000))

const TaskComp = ({ModalLoadded, setModalLoadded, setTexto, task, controlChangeOT, setControlChangeOT}) => {

  const {LoginState,SetLogin,CloseLogin,GetLoginSession} = useContext(LoginContext);

  
  const [DataTasks, setDataTasks] = useState(task);
  const [DataTasksBool, setDataTasksBool] = useState(false);

  const [NegSubTaskBool, setNegSubTaskBool] = useState(false);
  const [NegSubTaskText, setNegSubTaskText] = useState('');

  const [NegSubTasArr, setNegSubTasArr] = useState([]);
  const [NegSubTasArrBool, setNegSubTasArrBool] = useState(true);

  const [SubTasks, setSubTasks] = useState([]);
  const [SubTaskEdit, setSubTaskEdit] = useState([]);
  const [SubTask_Negatives, setSubTask_Negatives] = useState([]);
  const [CompleteTask, setCompleteTask] = useState(false);
  const [UserListFractal, setUserListFractal] = useState([]);
  /** RECURSO */
  const [RRHH_to_bd, setRRHH_to_bd] = useState('');
  const [UserListFractal_selected, setUserListFractal_selected] = useState('');
  const [MinutosRecurso, setMinutosRecurso] = useState(null);
  const [MinutosRecursocalc, setMinutosRecursocalc] = useState(0);
  const [ResourceList, setResourceList] = useState([]);
  const [ResourceListVerifi, setResourceListVerifi] = useState([]);

  const [value, setValue] = React.useState(0);

  // recurso humano
  const [UserListFracttal, setUserListFracttal] = useState([])
  const [UserListFracttal_BKP, setUserListFracttal_BKP] = useState([])
  const [TipoTrabajoPT, setTipoTrabajoPT] = useState("");
  const [RecHumPT, setRecHumPT] = useState(LoginState.rut);
  const [subtaskIsSave, setSubtaskIsSave] = useState(0);

  //  hora minutos
  const [Hora, setHora] = React.useState(0);
  const [Minutos, setMinutos] = React.useState(0);
  const [Fecha_, setFecha_] = React.useState(new Date().toISOString().split('T')[0]);

  // reload
  const [Reload_RH, setReload_RH] = useState(0);

  //hallazgos
  const [Hallazgo, setHallazgo] = useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  
  /** togglebutton  */
  const [alignment, setAlignment] = React.useState('');

  const handleAlignment = (event, newAlignment) => {
    setAlignment(newAlignment);
    // console.log(newAlignment);
  };

  /** MUTADORES DE ESTADO DRAWER */
	const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if(CompleteTask === true && open === false){
      // console.log("Cerrar Drawer",CompleteTask , open);
      let confClose = window.confirm("Esta seguro de salir, favor asegurese de guardar los cambios antes de salir.");
      if(confClose){
        setState({ ...state, [anchor]: open })
        setSubTaskEdit([])
        setTipoTrabajoPT('')
        setSubtaskIsSave(0)
      setRecHumPT('')
      setHora(0)
      setMinutos(0)
      }
    }else{
      setState({ ...state, [anchor]: open });
    }
  };

  /** metodos y logicas */
  const FormatMinutsTime = async (time_, m) => {
    if(time_ === 'HORA'){
      setHora(m);
    }
      setHora(m);
    console.log(m);
    setMinutosRecurso(m)
    if(m.includes(':')){
      let a = m.split(':')[0]
      let b = m.split(':')[1]
      setMinutosRecursocalc((a*60)+(Number(b)))
    }
    if(m==='')setMinutosRecursocalc(0)
  }

  useEffect(() => {
    if(Hora>=0 && Minutos>=0){
      setMinutosRecurso((Number(Hora) * 60) + Number(Minutos));
      setMinutosRecursocalc((Number(Hora) * 60) + Number(Minutos));
      // console.log("To Minutos", (Number(Hora) * 60) + Number(Minutos));
    }
  }, [Hora, Minutos])
  

  /** obtiene las subtareas para listarlas */
  const MenuTask = async (task) => {

    setModalLoadded(true)
    setTexto('Se estan Cargando las SubTareas.')

		// console.log("open menu Tasks", task.id_work_orders_tasks);
		const sortLsit = await GetSubTasks({subtask_id:task.id_work_orders_tasks,planta:LoginState.planta})
    let subTaskList = sortLsit?.sort((x,y) => x.id_work_orders_tasks_form_items - y.id_work_orders_tasks_form_items)
    await setSubTasks(subTaskList);
    // console.log("subtareas: ",subTaskList);
    let tempBulk = []
    for (let frt = 0; frt < subTaskList.length; frt++) {
      const frt_ = subTaskList[frt];
      
      if(frt_.id_task_form_item_type === 4 && frt_.value === null){
        // console.log('VERIFICACION');
        // console.log("subtareas 4: ",frt_ ,{
        //   "id_work_orders_tasks_form_items":frt_.id_work_orders_tasks_form_items,
        //   "id_task_form_item_type": frt_.id_task_form_item_type,
        //   "value":'1'
        // });

        await tempBulk.push({
          "id_work_orders_tasks_form_items":frt_.id_work_orders_tasks_form_items,
          "id_task_form_item_type": frt_.id_task_form_item_type,
          "value":'1'
        })
      }
      if(frt_.id_task_form_item_type === 2 && frt_.value === null){
        // console.log('SI/NO');

        // console.log("subtareas 2: ",frt_ ,{
        //   "id_work_orders_tasks_form_items":frt_.id_work_orders_tasks_form_items,
        //   "id_task_form_item_type": frt_.id_task_form_item_type,
        //   "value":'1'
        // });

        await tempBulk.push({
          "id_work_orders_tasks_form_items":frt_.id_work_orders_tasks_form_items,
          "id_task_form_item_type": frt_.id_task_form_item_type,
          "value":'true'
        })
      }
      else {
        // console.log("subtareas 4: ",frt_ ,{
        //   "id_work_orders_tasks_form_items":frt_.id_work_orders_tasks_form_items,
        //   "id_task_form_item_type": frt_.id_task_form_item_type,
        //   "value":'1'
        // });

        await tempBulk.push({
          "id_work_orders_tasks_form_items":frt_.id_work_orders_tasks_form_items,
          "id_task_form_item_type": frt_.id_task_form_item_type,
          "value":frt_.value?frt_.value:""
        })
      }
    }
    // MutadorSubtasks(tempBulk)
    
    let hash = {};
    tempBulk = await tempBulk.filter(o => hash[o.id_work_orders_tasks_form_items] ? false : hash[o.id_work_orders_tasks_form_items] = true);
    let ordenar = tempBulk?.sort((x,y) => x.id_work_orders_tasks_form_items - y.id_work_orders_tasks_form_items)
    setSubTaskEdit(ordenar)

    // ************************************************************************
    let rrhh_list = await ResourceList.map(rst => {
      // console.log(rst)
      if(rst.id_work_orders_tasks===task.id_work_orders_tasks){
        if(rst.source_description!=="Repuestos-Paico"){
          return rst.source_description===null?{name:rst.external_source, tiempo: rst.qty}:{name:rst.source_description, tiempo: rst.qty}
        }
        return null
      }
    })
    
    let null_out = rrhh_list.filter(item => item !== undefined)
    let null_out_ = null_out.filter(item => item !== null)

    // console.log(null_out_)
    if(null_out_.length>0){
      let bulk = await null_out_.map(r =>{
        let {name, tiempo} = r
        return {
          "nombre":r.name,
          "minutos":r.tiempo,
          "wo_folio":task.wo_folio,
          "id_work_orders_tasks":task.id_work_orders_tasks,
          "planta": LoginState.planta,}
      })
      // console.log(bulk)
      await BkpRRHH_fracttal({ACTION:"UPDATE",DATA:bulk})
    }else{
      await BkpRRHH_fracttal({ACTION:"UPDATE",DATA:{
          "wo_folio":task.wo_folio,
          "id_work_orders_tasks":task.id_work_orders_tasks,
          "planta": LoginState.planta,
          "elementos": 0
        }})    
    }

    // ************************************************************************

		setState({ ...state, ['right']: !state.right });
    setModalLoadded(false)
	}

  const MutadorSubtasks = async (data) => {
    // console.log(data)
    let find_x_ = SubTaskEdit.filter(asx=>asx.id_work_orders_tasks_form_items!==data.id_work_orders_tasks_form_items)
    let concatenado = find_x_.concat(data)
    let ordenar = concatenado?.sort((x,y) => x.id_work_orders_tasks_form_items - y.id_work_orders_tasks_form_items)
    // console.log(ordenar)
    setSubTaskEdit(ordenar)
  }

  /** ACTUALIZA LAS SUBTAREAS SELECCIONADAS y GENERA UNA SOLICITUD SI ESQUE ALGUNA DE LAS SUBTARES ES NEGATIVA */
  const HandleUpdateSubTask = async () => {

    setModalLoadded(true)
    setTexto('Se estan actualizando las SubTareas')
    // console.log('Se estan actualizando las SubTareas')

    // console.log(SubTaskEdit);
    if(NegSubTasArr.length === 0){
      // console.log('actualiza las subtareas');
      const update_ = await UpdateSubTask(SubTaskEdit) // ***************************************** ACTUALIZA LAS SUBTAREAS *****************************************
      // setState({ ...state, ['right']: !state.right })
      // setSubTaskEdit([])
      setModalLoadded(false)
    }else{

      // setModalLoadded(true)
      // console.log('Hay Subtareas Negativas')
      
      if(NegSubTasArrBool){
        setTexto('Se estan generando las solicitudes, favor no CIERRE o RECARGUE ESTA PAGINA.')
        // console.log('Se creraran SOLICITUDES PARA '+NegSubTasArr.length+' Subtareas con Observaciones Negativas')
        for (let nstks = 0; nstks < NegSubTasArr.length; nstks++) {
          const nstks_ = NegSubTasArr[nstks];

          let u_file = ''//contiene la url de la imagen cargada y si no se carga imagen se devuelve vacia

          if (nstks_.file.name) {
            console.log('hay archivo',(nstks_?.tsk_data?.id_work_orders_tasks_form_items || new Date().getTime()) ,nstks_.file, LoginState.planta);
            u_file = await UploadFile({taskID:(nstks_?.tsk_data?.id_work_orders_tasks_form_items || new Date().getTime()), file:nstks_.file, planta:LoginState.planta})// sube el archivo y devuelve la url para agregarlo al comentario de la solicitud
          }
          const update_ = await UpdateSubTask(SubTaskEdit) // ***************************************** ACTUALIZA LAS SUBTAREAS ***************************************** //
          //****************************************************** */
          // console.log("Solicitud a crear",{
          //   code:  task.code,// AGP LIGADO A LA TAREA
          //   description:"OBSERVACIONES: "+task.description,// OBSERVACIONES + NOMBREE DE LA TAREA
          //   comment:nstks_.tsk_data.description+":"+nstks_.comment+"\n"+u_file,// NEGATICO + OBSERVACION OBLIGATORIA
          //   name: task.user_assigned,// NOMBRE USUARIO LOGUEADO
          //   reference: task.wo_folio,// NUMERO DE OT
          //   planta:LoginState.planta
          // })
          //****************************************************** */
          const makeSoli = await CreaSolicitud({
            code:  task.code,// AGP LIGADO A LA TAREA
            description:"OBSERVACIONES: "+task.description,// OBSERVACIONES + NOMBREE DE LA TAREA
            comment:nstks_.tsk_data.description+":"+nstks_.comment+"\n"+u_file,// NEGATICO + OBSERVACION OBLIGATORIA
            name: task.user_assigned,// NOMBRE USUARIO LOGUEADO
            reference: task.wo_folio,// NUMERO DE OT
            planta:LoginState.planta
          })

        }
        setSubTaskEdit([])
        setNegSubTasArr([])
        setState({ ...state, ['right']: !state.right })
        await setTexto(`Se han generando ${NegSubTasArr.length} solicitudes.`)
        await setTimeout(async () => {
          await setModalLoadded(false)            
        }, 2000);
        /** GENERA UNA SOLICITUD AUTOMATICA */
        // console.log({code: task.code, description:task.description+": "+NegSubTaskText.toLocaleUpperCase(), comment:SubTask_Negatives.join(', '), name: task.user_assigned});
        // let description = task.description+" "+NegSubTaskText.toLocaleUpperCase()
        // const makeSoli = await CreaSolicitud({
        //   code: task.code,
        //   description:"OBSERVACIONES "+task.description,
        //   comment:SubTask_Negatives.join(', ')+" "+NegSubTaskText.toLocaleUpperCase(),
        //   name: task.user_assigned,
        //   reference: task.wo_folio
        // })
        // if(makeSoli){
        //   alert('Se ha creado una solicitud de trabajo!')
        //   
        // }
        // 
        
        
      }else{
        alert("Debe completar la observacion al final para continuar!!")
      }
    }
    alert("Se han actualizado las SubTareas")
  }

  /** obtiene la lista de los usuarios de fractal */
  const Get_User_list = async () => {
    let listUserF = await GetUserFracttal(LoginState.planta)
    await setUserListFractal(listUserF)
  }

  /** OBTIENE LOS RECURSOS HUMANOS DE LA TAREA */
  const GetResorceHuman = async () => {
    let rchmn = await GetResourceOT(task.wo_folio,LoginState.planta)
    setResourceList(rchmn)
    // console.log('Recursos Humanos:',rchmn);

    // lista de rrhh asignados a la tarea
    // let rrhh_list = await ResourceList.map(rst => {
    //   // console.log(rst)
    //   if(rst.id_work_orders_tasks===task.id_work_orders_tasks){
    //     if(rst.source_description!=="Repuestos-Paico"){
    //       return rst.source_description===null?{name:rst.external_source, tiempo: rst.qty}:{name:rst.source_description, tiempo: rst.qty}
    //     }
    //     return null
    //   }
    // })
    // let null_out = rrhh_list.filter(item => item !== undefined)
    // let null_out_ = null_out.filter(item => item !== null)
    // console.log(null_out_)
    // if(null_out_.length>0){
    //   let bulk = await null_out_.map(r =>{
    //     let {} = r
    //     return {
    //       "nombre":r.name,
    //       "minutos":r.tiempo,
    //       "wo_folio":task.wo_folio,
    //       "id_work_orders_tasks":task.id_work_orders_tasks,
    //       "planta": LoginState.planta,}
    //   })
    //   console.log(bulk)
    //   const BkpReasign = await BkpRRHH_fracttal({ACTION:"UPDATE",DATA:bulk})
    // }else{
    //   const BkpReasign = await BkpRRHH_fracttal({ACTION:"UPDATE",DATA:{
    //       "wo_folio":task.wo_folio,
    //       "id_work_orders_tasks":task.id_work_orders_tasks,
    //       "planta": LoginState.planta,
    //       "elementos": 0
    //     }})    
    // }

  }

  /** AGREGA UN RECURSO HUMANO A LA TAREA */
  const AddresouseHuman = async (rut, minutos, wo_folio, taskID) => {
    // console.log("TO DB:", wo_folio, taskID, minutos, RRHH_to_bd,LoginState.planta);
    setModalLoadded(true)
    setTexto('cargando ...')

    //*********************************************************************** */
    let rrhh_list = await ResourceList.map(rst => {
      // console.log(rst)
      if(rst.id_work_orders_tasks===taskID){
        if(rst.source_description!=="Repuestos-Paico"){
          return rst.source_description===null?{name:rst.external_source, tiempo: rst.qty}:{name:rst.source_description, tiempo: rst.qty}
        }
        return null
      }
    })
    
    let null_out = rrhh_list.filter(item => item !== undefined)
    let null_out_ = null_out.filter(item => item !== null)

    console.log(null_out_)
    if(null_out_.length>0){
      let bulk = await null_out_.map(r =>{
        let {name, tiempo} = r
        return {
          "nombre":r.name,
          "minutos":r.tiempo,
          "wo_folio":task.wo_folio,
          "id_work_orders_tasks":task.id_work_orders_tasks,
          "planta": LoginState.planta,}
      })
      console.log(bulk)
      await BkpRRHH_fracttal({ACTION:"UPDATE",DATA:bulk})
    }else{
      await BkpRRHH_fracttal({ACTION:"UPDATE",DATA:{
          "wo_folio":task.wo_folio,
          "id_work_orders_tasks":task.id_work_orders_tasks,
          "planta": LoginState.planta,
          "elementos": 0
        }})    
    }
    //*********************************************************************** */
    
      //envia los datos de recurso humano a la base de datos
    await BkpRRHH_fracttal({ACTION:"ADD",DATA:{
      "wo_folio":wo_folio,
      "id_work_orders_tasks":taskID,
      "minutos":minutos/60,
      "nombre": RRHH_to_bd,
      "planta": LoginState.planta
    }})
    
    let ResourceFilter = ResourceList.filter(r => r.id_work_orders_tasks === task.id_work_orders_tasks)
    
    if(ResourceFilter.length===0 || ResourceFilter[0].source_description==="Repuestos-Paico"){
      console.log("AGREGA REGISTRO PORQUE NO HAY RECURSOS");
      let a = new Date(Fecha_+"T"+new Date().toISOString().split('T')[1])// ESTE DEBE SER LA FECHA SELECCIONADA Y LA HORA ACTUAL
      let b = new Date(Fecha_+"T"+new Date().toISOString().split('T')[1])// ESTE DEBE SER LA FECHA SELECCIONADA Y LA HORA ACTUAL
      a.setMinutes(a.getMinutes() - 1);
      /** agrega un recurso humano a la tarea seleccionada */
      await AddRegistro({taskID:taskID, fechas:{start: a.getTime(), end: b.getTime()}, planta:LoginState.planta})
      alert("Se ha agregado un registro con los datos del recurso humano agregado")
    }
    let adresou = await AddResouceH({rut, minutos, wo_folio, taskID, planta:LoginState.planta})

    if(adresou){
      setUserListFractal_selected('')
      setMinutosRecurso(null)
      setMinutosRecursocalc('')
      setTipoTrabajoPT('')
      setRecHumPT('')
      setHora(0)
      setMinutos(0)
      await GetResorceHuman()
    }else{
      await GetResorceHuman()
      setUserListFractal_selected('')
      setMinutosRecurso(null)
      setMinutosRecursocalc('')
      setTipoTrabajoPT('')
      setRecHumPT('')
      setHora(0)
      setMinutos(0)
    }
    setModalLoadded(false)
  }

  /** ELIMINA UN RECURSO */
  const DeleteResource = async (data) => {
    let dltrsce = await DeleteResouceH(data)
  }

  /** AGREGA A UN ARRAY LAS SUBTAREAS NEGATIVAS */
  const AddNegativeTaskArr = async (is_tsk) => {
    // console.log(is_tsk);//setNegSubTasArr
    if(NegSubTasArr.length === 0){
      setNegSubTasArr([{
        id_wot_fid:is_tsk,
        comment:'',
        tsk_data: [],
        file: []
      }])
    }else{
      let find_tskNg = await NegSubTasArr.find(ts_k => ts_k.id_wot_fid === is_tsk)
      if(!find_tskNg)setNegSubTasArr([...NegSubTasArr,{
        id_wot_fid:is_tsk,
        comment:'',
        tsk_data: [],
        file: []
      }])
    }
  }



  /** QUITA AL ARRAY UNA SUBTAREAS NEGATIVA SEGUN ID */
  const SubbtractNegativeTaskArr = async (q_tsk) => {
    // console.log('QUITAR TASK', q_tsk);
    let f_negtv = await NegSubTasArr.filter(tsk => tsk.id_wot_fid !== q_tsk)
    await setNegSubTasArr(f_negtv)
  }

  /** AGREGA COMENTARIO Y ARCHIVO AL NEGATIVO */
  const AddParamsToNegativTask = async (id_tsk, data, tskdata, type) => {/******************************************************************************************************* */
    // console.log(id_tsk, data, tskdata, type);
    /** filtrar por el id el igual y apartarlo para modificarlo */
    let equal_ = await NegSubTasArr.filter(a=>a.id_wot_fid===id_tsk)
    let not_equal_ = await NegSubTasArr.filter(a=>a.id_wot_fid!==id_tsk)
    if(type === "comment"){
      equal_[0].tsk_data = tskdata
      equal_[0].comment = data
    }else if (type === "file"){
      equal_[0].tsk_data = tskdata
      equal_[0].file = data
    }
    setNegSubTasArr(equal_.concat(not_equal_))
    // console.log(equal_);
    /** flitar por el id los distintos para luego concatenarlo con el modificado y reemplazar el setNegSubTasArr(data) */
    /** luego al guardar enviar de uno por vez para crear solicitudes y enviar alertas de creacion de solicitudes */
  }

  useEffect(() => {
    // console.log(SubTaskEdit)
    const funcion_asincrona = async () => {
      const complete = SubTaskEdit.filter(stsk => stsk.value !== "")
      let arrTemp = []
      /** BUSCA SUBTAREAS NEGATIVAS */
      for (let stk = 0; stk < complete.length; stk++) {
        const stk_ = complete[stk];
        // console.log(stk_);
        if(stk_.id_task_form_item_type === 2 && stk_.value === "false" || stk_.id_task_form_item_type === 4 && stk_.value === "3"  || stk_.id_task_form_item_type === 4 && stk_.value === "2"){
          // console.log(stk_.id_work_orders_tasks_form_items, SubTasks);
          let find_ = await SubTasks.find(fnd => fnd.id_work_orders_tasks_form_items === stk_.id_work_orders_tasks_form_items)
          // console.log(find_);
          arrTemp.push(find_.description)
        }
        // if(arrTemp.length >= 1)alert("debe tener un campo de observaciones obligatorio para generar solicitud de tarea")
      }
      /** almacena las subtareas con resultado negativo para generar un solicitud de trabajo */
      // console.log(arrTemp);
      /** verifica que existan subtareas negativas para generar un cuadro de descripcion el cuial es oblidatorio */
      if(arrTemp.length >= 1){
        setNegSubTaskBool(true)
      }else{
        setNegSubTaskText('')
        setNegSubTaskBool(false)
      }
      
      await setSubTask_Negatives(arrTemp)

      if(complete.length >= 1)setCompleteTask(true)
      else setCompleteTask(false)
    }
    funcion_asincrona()
  }, [SubTaskEdit])
  
  useEffect(() => {
    // console.log(NegSubTasArr)
    const FindNegativeSinCompletar = async () => {
      setNegSubTasArrBool(true)
      for (let fnsc = 0; fnsc < NegSubTasArr.length; fnsc++) {
        const fnsc_ = NegSubTasArr[fnsc];
        if(fnsc_.comment === "") setNegSubTasArrBool(false)
      }
    }
    FindNegativeSinCompletar()
    return () => {
      FindNegativeSinCompletar()
    }
  }, [NegSubTasArr])
  
  useEffect(() => {
    Get_User_list()
    // console.log("Recursos Humanos Actualizados")
    GetResorceHuman()
    return () => {
      Get_User_list()
      GetResorceHuman()
    }
  }, [Reload_RH])

  const [planaState, setPlanaState] = useState({
    plana_1: true,
    plana_2: false,
    plana_3: false
  })

  const nextView = (plano) => {
    // console.log("Siguiente vista:", plano);
    switch (plano) {
      case 1:
        setPlanaState({ plana_1: true, plana_2: false, plana_3: false });
        break;
      case 2:
        setPlanaState({ plana_1: false, plana_2: true, plana_3: false });
        break;
      case 3:
        setPlanaState({ plana_1: false, plana_2: false, plana_3: true });
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    // console.log(task.code);
    const LoadUsersFromFracttal = async () => {
      let query = await fetch(URL_SRV_RAIZ+'getuser_fracttal_planta_nof',{//'getuser_fracttal',{
        method: "POST",
        headers: {
          'authorization': "marcuxo",
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          PLANTA: LoginState.planta.toUpperCase()
        })
      })

      let responsio = await query.json();
      // console.log(responsio)
      let map = await responsio.body.map((item) => {
          let {RUT,NOMBRE,CARGO} = item
          return { value: RUT, label: NOMBRE , CARGO: CARGO.toUpperCase(), CONTACTO: item.CONTACTOS || [] }
        })
        //   console.log("Usuarios Fracttal",map);

        setUserListFracttal(map);
        setUserListFracttal_BKP(map);
    }
    LoadUsersFromFracttal()
  }, [])

  useEffect(() => {
    // console.log(UserListFracttal)
    if(TipoTrabajoPT !== ""){
        let filterList = UserListFracttal.filter(item => item.CARGO.toLowerCase().includes(TipoTrabajoPT.toLowerCase()));
        console.log(filterList)
        setUserListFracttal_BKP(filterList);
      }else{
        setUserListFracttal_BKP(UserListFracttal);
      }
  }, [TipoTrabajoPT])

  /** cambia el status de la ot */
  const HandleChangeStatus = async (wo_folio) => {
    // console.log('Vamos a cambiar el estado de esta OT', wo_folio);
    let toRevcn = window.confirm(`Esta seguro de enviar la ${wo_folio} a revision?`)
    if(toRevcn){
      let chg_status = await StatusToRevcn({wo_folio:wo_folio,status:2,planta:LoginState.planta})
      await setControlChangeOT(controlChangeOT+1)
      setState({ ...state, ["right"]: false })
    }
  }

  return (
    <Fragment>
      <div className='puntero pb-4' onClick={()=>MenuTask(task)}>
        <div className='col-12 pt-3' style={{borderTop: "1px solid #acacac"}}>
          <div className='row'>
            <div className='col-1 center-v'>
              <Typography component={'span'}><VisibilityIcon style={{color:"#acacac"}} /></Typography>
            </div>
            <div className='col-11'>
              <Typography component={'span'}>{task.items_log_description}</Typography><br/>
              <Typography component={'span'} className='text-02'>{task.parent_description}</Typography>
            </div>
          </div>
          <hr style={{height:"1px", backgroundColor: "#CACACA", padding: "0px", margin: "0px"}}/>
        </div>
        <div className='col-12'>
          <Typography component={'span'}>{task.description}</Typography>
        </div>
        <div className='col-12' title='Detalle de Tarea'>
          <div className='row'>

            <div className='col-11'>
              <div className='row'>

                <div className='col-5' >
                  <Typography component={'span'} className='text-info text-02'>Tipo de Tarea:</Typography>
                </div>
                <div className='col-7' >
                  <Typography component={'span'} className='text-02'>{task.tasks_log_task_type_main}</Typography>
                </div>
                
                <div className='col-5' >
                  <Typography component={'span'} className='text-info text-02'>Clasificacion 1:</Typography>
                </div>
                <div className='col-7' >
                  <Typography component={'span'} className='text-02'>{task.tasks_log_types_description}</Typography>
                </div>

                <div className='col-5' >
                  <Typography component={'span'} className='text-info text-02'>Clasificacion 2:</Typography>
                </div>
                <div className='col-7' >
                  <Typography component={'span'}className='text-02'>{task.tasks_log_types_2_description}</Typography>
                </div>

                <div className='col-5' >
                  <Typography component={'span'} className='text-info text-02'>Nro Solicitud:</Typography>
                </div>
                <div className='col-7' >
                  <Typography component={'span'}></Typography>
                </div>

                <div className='col-5' >
                  <Typography component={'span'} className='text-info text-02'>Fecha Programada:</Typography>
                </div>
                <div className='col-7' >
                  <Typography component={'span'} className='text-02'>{String(task.date_maintenance).split("T")[0]}</Typography>
                </div>

                <div className='col-5' >
                  <Typography component={'span'} className='text-info text-02'>Duracion Estimada:</Typography>
                </div>
                <div className='col-7' >
                {/* {console.log(Math.floor(Math.trunc((task.duration/60)/60)))} */}
                  <Typography component={'span'} className='text-02'>
                  {
                    task.duration/60>59?
                    (Math.floor(Math.trunc((task.duration/60)/60))>=10?
                    Math.floor(Math.trunc((task.duration/60)/60))
                    :"0"+Math.floor(Math.trunc((task.duration/60)/60)))+":"+((task.duration/60)-(60*(Math.floor(Math.trunc((task.duration/60)/60)))))
                    :"00:"+task.duration/60
                  }
                  </Typography>
                </div>

              </div>
            </div>
            <div className='col-1 center-v'>
              {/* <div className='row'> */}
                {/* <div className='col-1 '> */}
                  <Typography component={'span'}><ArrowForwardIosIcon style={{color:"#acacac"}} /></Typography>
                {/* </div> */}
              {/* </div> */}
            </div>

          </div>
        </div>
        <div className='col-12 mt-2'>
          <div className='row'>
            <div className='col-6'>
              {
                task.completed_percentage===100?
                <Typography component={'span'} className='comlpete-task-badge'><TaskAltIcon color='success' />Completado</Typography>: null
              }
            </div>
          </div>
        </div>
      </div>

    {/* Drawer */}
      <Drawer
        anchor={'right'}
        open={state['right']}
        onClose={toggleDrawer('right', false)}
        id={task.id_task}
        key={task.id_task}
      >
      <div className='container' id="drawer-tasks-01" style={{width: "600px"}}>
        <div className='row'>
          {/* header fijo */}
          <div className='col-12' style={{height: "5vh", borderBottom: "1px solid #ff0000ff"}}>
            <div className='row'>
              <div className='col-2'>
                <ArrowBackIosIcon color='info' label="Volver" onClick={toggleDrawer('right', false)}/>
              </div>
              <div className='col-10'>
                <span>{task.items_log_description}</span>
              </div>
            </div>
          </div>
          {/* body fijo con scroll */}
          <div className='col-12' style={{height: "95vh"}}>
            <div className='row'>

                 {/* vista 1 [SUBTAREAS]*/}
            <div className={planaState.plana_1 ? 'col-12 pb-3 plana_1-show' : 'col-12 plana_1-hidden'} id='plana_1' style={{height: "95vh", overflowY: "scroll"}}>
              <div className='col-12 mt-3'>
                <div className='row '>
                    <div className='col-12 py-1 bg-secondary' style={{}}>
                      <h5 className='text-center text-white'>Descripción Trabajo Realizado</h5>
                    </div>
                    {
                      task?.task_note&&<div className='col-12 pt-3'>
                      <TextField 
                        label="Nota de Trabajo"
                        fullWidth
                        size='small'
                        id="outlined-multiline-static"
                        multiline
                        rows={task.task_note.split('\n').length+1}
                        value={task.task_note}
                        sx={{
                          '& .MuiInputBase-input': {
                            fontSize: '12px', // Tamaño de fuente personalizado
                          }
                        }}
                      />
                    </div>
                    }
                    
                    {
                      SubTasks.map((tsk,index) =>(
                        tsk.id_task_form_item_type===1?
                          <div className='col-12 py-3' key={tsk.id_work_orders_tasks_form_items} style={{borderBottom: "1px solid #D5D3D3"}}>
                            <label style={{color: "gray"}}>{tsk.description} <b>{tsk.is_required ? '*' : ''}</b></label>
                            <TextField
                              fullWidth
                              size='small'
                              id="outlined-multiline-static"
                              multiline
                              rows={4}
                              value={SubTaskEdit[index]?.value}
                              onChange={(e)=>MutadorSubtasks({
                                ["id_work_orders_tasks_form_items"]:tsk.id_work_orders_tasks_form_items,
                                ["id_task_form_item_type"]: tsk.id_task_form_item_type,
                                ["value"]:e.target.value
                                })}
                            />
                          </div>
                        : tsk.id_task_form_item_type===2?
                          <div className='col-12 py-3' key={tsk.id_work_orders_tasks_form_items} style={{borderBottom: "1px solid #D5D3D3"}}>
                            <label style={{color: "gray"}}>{tsk.description} <b>{tsk.is_required ? '*' : ''}</b></label>
                            <ToggleButtonGroup
                              fullWidth
                              exclusive
                              value={SubTaskEdit[index]?.value}
                              // onChange={handleAlignment}
                              // value={SubTaskEdit[index]?.value}
                              onChange={(e)=>MutadorSubtasks({
                                ["id_work_orders_tasks_form_items"]:tsk.id_work_orders_tasks_form_items,
                                ["id_task_form_item_type"]: tsk.id_task_form_item_type,
                                ["value"]:e.target.value
                                })}
                              defaultValue={"true"}
                            >
                              <ToggleButton
                                className={SubTaskEdit[index]?.value==="true"?'btn-green-active':'btn-green'}
                                onClick={()=>SubbtractNegativeTaskArr(tsk.id_work_orders_tasks_form_items)}
                                value="true">SI</ToggleButton>
                              <ToggleButton
                                className={SubTaskEdit[index]?.value==="false"?'btn-rojo-active':'btn-rojo'}
                                onClick={()=>AddNegativeTaskArr(tsk.id_work_orders_tasks_form_items)}
                                value="false">NO</ToggleButton>
                              <ToggleButton
                                className={SubTaskEdit[index]?.value==="N/A"?'btn-na-active':'btn-na'}
                                onClick={()=>SubbtractNegativeTaskArr(tsk.id_work_orders_tasks_form_items)}
                                value="N/A">N/A</ToggleButton>
                            </ToggleButtonGroup>
                            {
                              SubTaskEdit[index]?.value === 'false'?
                              <div className='col-12 p-0 m-0'>
                                <div className='row'>
                                  <div className='col-10'>
                                    <label style={{color: "rgb(255,0,0"}}>OBSERVACION PARA CREAR SOLICITUD AUTOMATICA*</label>
                                    <TextField
                                      color='error'
                                      focused
                                      fullWidth
                                      size='small'
                                      id="outlined-multiline-static-1"
                                      multiline
                                      rows={3}
                                      onChange={(e)=>AddParamsToNegativTask(tsk.id_work_orders_tasks_form_items,e.target.value,tsk,'comment')}
                                    />
                                  </div>
                                  <div className='col-2 center-v pt-5'>
                                    <Button component="label" color='secondary' variant="contained"><AttachmentIcon />
                                      <VisuallyHiddenInput
                                        accept='image/jpeg'
                                        type="file"
                                        onChange={(e)=>{AddParamsToNegativTask(tsk.id_work_orders_tasks_form_items,e.target.files[0],tsk,'file')}}
                                      />
                                    </Button>
                                    <small style={{color:'#CACACA'}}>Max. 2MB</small>
                                  </div>
                                </div>
                              </div>:null
                            }
                          </div>
                        : tsk.id_task_form_item_type===3?
                          <div className='col-12 py-3' key={tsk.id_work_orders_tasks_form_items} style={{borderBottom: "1px solid #D5D3D3"}}>
                            <label style={{color: "gray"}}>{tsk.description} <b>{tsk.is_required ? '*' : ''}</b></label>
                            <TextField
                              fullWidth
                              size='small'
                              id="outlined-multiline-static"
                              type='number'
                              value={SubTaskEdit[index]?.value}
                              onChange={(e)=>MutadorSubtasks({
                                ["id_work_orders_tasks_form_items"]:tsk.id_work_orders_tasks_form_items,
                                ["id_task_form_item_type"]: tsk.id_task_form_item_type,
                                ["value"]:e.target.value
                                })}
                            />
                          </div>
                        : tsk.id_task_form_item_type===5?
                          <div className='col-12 py-3' key={tsk.id_work_orders_tasks_form_items} style={{borderBottom: "1px solid #D5D3D3"}}>
                            <label style={{color: "gray"}}>{tsk.description} <b>{tsk.is_required ? '*' : ''}</b></label>
                            <TextField
                              fullWidth
                              size='small'
                              id="outlined-multiline-static"
                              type='number'
                              value={SubTaskEdit[index]?.value}
                              onChange={(e)=>MutadorSubtasks({
                                ["id_work_orders_tasks_form_items"]:tsk.id_work_orders_tasks_form_items,
                                ["id_task_form_item_type"]: tsk.id_task_form_item_type,
                                ["value"]:e.target.value
                                })}
                            />
                            <small>Medidor: <b>{tsk.meter_description}</b></small><br/>
                            <small>Unidad: <b>{tsk.unit_description}</b></small><br/>
                            <small>Última lectura: <b>{tsk.last_value}</b></small>

                          </div>
                        : tsk.id_task_form_item_type===7?
                          <div className='col-12 py-3' key={tsk.id_work_orders_tasks_form_items} style={{borderBottom: "1px solid #D5D3D3"}}>
                            <label style={{color: "gray"}}>{tsk.description} <b>{tsk.is_required ? '*' : ''}</b></label>
                            
                            <FormControl fullWidth size="small">
                              <Select
                                labelId="demo-select-small-label"
                                id="demo-select-small"
                                value={SubTaskEdit[index]?.value}
                                onChange={(e)=>MutadorSubtasks({
                                  ["id_work_orders_tasks_form_items"]:tsk.id_work_orders_tasks_form_items,
                                  ["id_task_form_item_type"]: tsk.id_task_form_item_type,
                                  ["value"]:e.target.value
                                  })}
                              >
                                
                                <MenuItem value={"Se detecto Óxido, se limpia y trata, equipo queda libre de Óxido"}>Se detecto Óxido, se limpia y trata, equipo queda libre de Óxido</MenuItem>
                                <MenuItem value={"No se detecta Óxido"}>No se detecta Óxido</MenuItem>
                              </Select>
                            </FormControl>

                          </div>
                        :<div className='col-12 py-3' key={tsk.id_work_orders_tasks_form_items} style={{borderBottom: "1px solid #D5D3D3"}}>
                          <label style={{color: "gray"}}>{tsk.description} <b>{tsk.is_required ? '*' : ''}</b></label>
                          <ToggleButtonGroup
                            fullWidth
                            exclusive
                            value={SubTaskEdit[index]?.value}
                            onChange={(e)=>MutadorSubtasks({
                              ["id_work_orders_tasks_form_items"]:tsk.id_work_orders_tasks_form_items,
                              ["id_task_form_item_type"]: tsk.id_task_form_item_type,
                              ["value"]:e.target.value
                              })}
                              defaultValue={"1"}
                          >
                            <ToggleButton
                              className={SubTaskEdit[index]?.value==="1"?'btn-green-active':'btn-green'}
                              onClick={()=>SubbtractNegativeTaskArr(tsk.id_work_orders_tasks_form_items)}
                              value="1">APROBÓ</ToggleButton>
                            <ToggleButton
                              className={SubTaskEdit[index]?.value==="2"?'btn-naranjo-active':'btn-naranjo'}
                              onClick={()=>AddNegativeTaskArr(tsk.id_work_orders_tasks_form_items)}
                              value="2">ALERTA</ToggleButton>
                            <ToggleButton
                              className={SubTaskEdit[index]?.value==="3"?'btn-rojo-active':'btn-rojo'}
                              onClick={()=>AddNegativeTaskArr(tsk.id_work_orders_tasks_form_items)}
                              value="3">FALLÓ</ToggleButton>
                          </ToggleButtonGroup>
                          {
                              SubTaskEdit[index]?.value === '2' || SubTaskEdit[index]?.value === '3'?
                              <div className='col-12 p-0 m-0'>
                                <div className='row'>
                                  <div className='col-10'>
                                    <label style={{color: "rgb(255,0,0"}}>OBSERVACION PARA CREAR SOLICITUD AUTOMATICA*</label>
                                    <TextField
                                      color='error'
                                      focused
                                      fullWidth
                                      size='small'
                                      id="outlined-multiline-static-2"
                                      multiline
                                      rows={3}
                                      onChange={(e)=>AddParamsToNegativTask(tsk.id_work_orders_tasks_form_items,e.target.value,tsk,'comment')}
                                    />
                                  </div>
                                  <div className='col-2 center-v pt-5'>
                                    <Button component="label" color='secondary' variant="contained"><AttachmentIcon />
                                      <VisuallyHiddenInput size={1500} accept='image/jpeg' type="file" onChange={(e)=>AddParamsToNegativTask(tsk.id_work_orders_tasks_form_items,e.target.files[0],tsk,'file')} />
                                    </Button>
                                    <small style={{color:'#CACACA'}}>Max. 2MB</small>
                                  </div>
                                </div>
                              </div>:null
                            }
                        </div>
                      ))
                    }

{/* HALLAZGO */}
                    <div className='col-12 my-2 pb-2' style={{borderBottom: "1px solid #D5D3D3"}}>
                      <span>Desea reportar algun hallazgo?</span>
                        <Switch
                          defaultChecked
                          label="Desea reportar algun hallazgo?"
                          color='success'
                          checked={Hallazgo}
                          onChange={(e) =>{
                            setHallazgo(e.target.checked);
                            if(e.target.checked){
                              AddNegativeTaskArr(task.id_work_orders_tasks);
                            }
                            else{
                              SubbtractNegativeTaskArr(task.id_work_orders_tasks);
                            }
                            }}
                        />
                        {
                          Hallazgo?
                          <div className='col-12 p-0 m-0'>
                            <div className='row'>
                              <div className='col-10'>
                                <label style={{color: "rgb(255,0,0"}}>Observación para crear una solicitud por el hallazgo*</label>
                                {/* <label style={{color: "rgb(255,0,0"}}>{task.code}</label> */}
                                <TextField
                                  color='error'
                                  focused
                                  fullWidth
                                  size='small'
                                  id="outlined-multiline-static-2"
                                  multiline
                                  rows={3}
                                  onChange={(e)=>AddParamsToNegativTask(task.id_work_orders_tasks,e.target.value,task,'comment')}
                                />
                              </div>
                              <div className='col-2 center-v pt-5'>
                                <Button component="label" color='secondary' variant="contained"><AttachmentIcon />
                                  <VisuallyHiddenInput
                                    size={1500}
                                    accept='image/jpeg'
                                    type="file"
                                    onChange={(e)=>AddParamsToNegativTask(task.id_work_orders_tasks,e.target.files[0],task,'file')}
                                  />
                                </Button>
                                <small style={{color:'#CACACA'}}>Max. 2MB</small>
                              </div>
                            </div>
                          </div>:null
                        }
                      </div> 
                      
                        <small style={{color: "#100f528f"}}>↘️Debe presionar guardar para ver el botón continuar⬇️.</small>
                      <div className='col-12 text-left  mt-1'>
                        {/* <SaveIcon style={CompleteTask||NegSubTasArrBool?{color: "#1976d2", cursor: 'pointer'}:{color: "#ACACAC"}} 
                          onClick={CompleteTask||NegSubTasArrBool?()=>HandleUpdateSubTask():null}
                        />*/}

                        {/* boton guardar cambios en subtareas */}
                        <button
                          className='btn btn-primary'
                          disabled={!CompleteTask||!NegSubTasArrBool}
                          onClick={()=>{
                            HandleUpdateSubTask()
                            setSubtaskIsSave(subtaskIsSave+1)

                            const scrollY = document.getElementById('plana_1');
                            setTimeout(() => {
                              scrollY.scrollTo({
                                top: scrollY.scrollTop + 100,
                                behavior: 'smooth'
                              })
                            }, 500);
                            }}>Guardar</button>

                            {/* <span onClick={()=> console.log(NegSubTasArr)}>console.log()</span> */}

                          {/* onClick={CompleteTask||NegSubTasArrBool?()=>HandleUpdateSubTask():null}>Guardar</button> */}
                      </div>

                    </div>
              </div>
              <div className='col-12 mt-3 text-center'>
               {subtaskIsSave>=1?
                <button className='btn btn-danger' onClick={()=>{
                  nextView(3)
                  GetResorceHuman()
                  }}><ArrowForwardIcon /></button>:null
               }
              </div>
            </div>
              
              {/* vista 3 [APOYO RR.HH ADICIONAL]*/}
            <div className={planaState.plana_3 ? 'col-12 pl-4 pb-3 plana_3-show' : 'col-12 plana_3-hidden'} id='plana_3' style={{ height: "95vh", overflowY: "scroll"}}>
              <div className='row card-ot-crud-2'>
                <div className='col-12 text-center bg-secondary py-1'> 
                  <h5 className=' text-center text-white'>Apoyo RR.HH Adicional</h5>
                </div>
                <div className='col-12' style={{borderBottom: '3px solid #CACACA', marginBottom: '15px'}}>
                {
                  ResourceList&&
                  ResourceList.length>=1?
                    <table className="table table-sm" style={{fontSize: 'small'}}>
                    {/* {console.log(ResourceList)} */}
                      <thead>
                        <tr>
                          <th scope="col">Nombre</th>
                          <th scope="col">Tiempo</th>
                          {/* <th scope="col">Accion</th> */}
                        </tr>
                      </thead>
                      <tbody>
                      {
                        ResourceList.map(rst => (

                          rst.id_work_orders_tasks===task.id_work_orders_tasks?
                            <tr key={rst.id_wo_resource}>
                            {
                              rst.source_description==="Repuestos-Paico"?null:<>
                              <td>{rst.source_description===null?rst.external_source:rst.source_description}</td>
                              <td>{rst.qty} hrs</td></>
                            }
                              {/* <td className='text-center'>
                                <DeleteIcon className='' color='error' onClick={()=>DeleteResource({folio:rst.wo_folio,id_wo_task: rst.id_work_orders_tasks, id_wo_resource: rst.id_wo_resource})} />
                              </td> */}
                            </tr>:null
                          
                        ))
                      }
                        
                      </tbody>
                    </table>:<span>Sin Recursos</span>
                }
                </div>
                {/* area de seleccion de recurso humano con fecha y hora */}
                <div className='col-12' style={{border: '1px '}}>
                  <span>SELECCIONE RECURSOS HUMANO</span>
                  <div className='row'>
                  {/* SELECCION DE TIPO DE TRABAJO */}
                    <div className='col-12 col-md-6 pt-3'>
                      <FormControl fullWidth>
                        <InputLabel size='small' id="demo-simple-select-label">Tipo de trabajo</InputLabel>
                        <Select
                          size='small'
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="Tipo de trabajo"
                          value={TipoTrabajoPT}
                          onChange={(e)=>setTipoTrabajoPT(e.target.value)}
                        >
                          {/* <MenuItem value={"EFICIENCIA ENERGETICA"}>Eficiencia Energetica</MenuItem> */}
                          {/* <MenuItem value={"ADMINISTRATIVO"}>Administrativo</MenuItem> */}
                          <MenuItem value={"ELECTRICA"}>Eléctrica</MenuItem>
                          {/* <MenuItem value={"EXTERNO"}>Externo</MenuItem> */}
                          <MenuItem value={"MECANICA"}>Mecánica</MenuItem>
                          <MenuItem value={"REDES Y SERVICIOS"}>Redes y Servicios Eléctricos</MenuItem>
                          <MenuItem value={"SALA DE MAQUINAS"}>Sala de Máquinas</MenuItem>
                          <MenuItem value={"SERVICIOS VARIOS"}>Servicios Varios</MenuItem>
                          <MenuItem value={"SUPERVISOR"}>Supervisor</MenuItem>
                          <MenuItem value={"EXTERNO"}>Externo</MenuItem>
                          {/* <MenuItem value={"-"}>No categorizados</MenuItem> */}
                        </Select>
                      </FormControl>
                    </div>

                  {/*  SELECCION DE RESPONSABLE */}
                    <div className='col-12 col-md-6 pt-3'>
                      <FormControl fullWidth>
                        <InputLabel size='small' id="demo-simple-select-label">Responsable</InputLabel>
                        <Select
                          size='small'
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="Responsable"
                          value={RecHumPT}
                          onChange={(e)=>{
                              setRecHumPT(e.target.value)
                              TipoTrabajoPT==="EXTERNO"?
                              setRRHH_to_bd(e.target.value)
                              :
                                setRRHH_to_bd(UserListFracttal_BKP.filter(usr=>usr.value===e.target.value)[0]?.label)
                              
                            }
                          }
                        >
                          {
                            TipoTrabajoPT==="EXTERNO"?
                            UserListFracttal_BKP.map((usrfttl, index)=>
                                usrfttl.CONTACTO.map((ctt,i)=>
                                  <MenuItem key={index+'-'+i} style={{fontFamily: 'monospace',fontSize: '10'}}  value={ctt}><small>{ctt}</small></MenuItem>
                                )
                            )
                            :
                            UserListFracttal_BKP.map((usrfttl, index)=>
                                <MenuItem key={index} style={{fontFamily: 'monospace',fontSize: '10'}}  value={usrfttl.value}><small>{usrfttl.label}</small></MenuItem>
                            )
                          }
                        </Select>
                      </FormControl>
                    </div>

                    {/*  seleccion de hora y minutos */}
                    <div className='col-12 my-3'>
                        <div className='row'>
                          <div className='col-6'>
                            <label style={{position: 'absolute', bottom: 22, marginLeft: 10, backgroundColor: 'white', padding: '0px 5px 0px 5px'}}><small>HORA</small></label>
                            <input
                              type='number'
                              min={0}
                              max={24}
                              step={1}
                              value={Hora}
                              onChange={(e)=>{
                                let value = e.target.value;
                                if(value.includes('.')){
                                  e.target.value = value.replace('.', '');
                                  console.log(e.target.value);
                                  setHora(Number(e.target.value));
                                }else{
                                  if(value>=0 && value<=24)setHora(Number(e.target.value));
                                }
                              }}
                              style={{ borderRadius: 5, border: '1px solid #CACACA', width: '100%', padding: '10px 5px 5px 10px' }} />
                          </div>
                          <div className='col-6'>
                            <label style={{position: 'absolute', bottom: 22, marginLeft: 10, backgroundColor: 'white', padding: '0px 5px 0px 5px'}}><small>MINUTO</small></label>
                            <select
                              value={Minutos}
                              onChange={(e)=>{
                                let value = e.target.value;
                                if(value.includes('.')){
                                  e.target.value = value.replace('.', '');
                                  setMinutos(Number(e.target.value));
                                }else{
                                  setMinutos(Number(e.target.value));
                                }
                              }}
                              style={{ borderRadius: 5, border: '1px solid #CACACA', width: '100%', padding: '10px 5px 5px 10px' }}
                            >
                              <option value="">SELECCIONE MINUTOS</option>
                              <option value={0}>0 MINUTOS</option>
                              <option value={15}>15 MINUTOS</option>
                              <option value={30}>30 MINUTOS</option>
                              <option value={45}>45 MINUTOS</option>
                            </select>
                          </div>
                        </div>
                    </div>

                    {/* SELECTOR DE FECHA PARA LA FUNCION [AddRegistro] */}
                    {
                      ResourceList.length===0 &&
                      <div className='col-12 my-3'>
                        <label 
                        style={{
                          position: 'absolute',
                          bottom: 25,
                          marginLeft: 10,
                          backgroundColor: 'white',
                          padding: '0px 5px 0px 5px'
                          }}>
                            <small>FECHA</small>
                        </label>
                        <input
                          max={new Date().toISOString().split("T")[0]}
                          type='date'
                          value={Fecha_}
                          onChange={(e)=>setFecha_(e.target.value)}
                          style={{ borderRadius: 5, border: '1px solid #CACACA', width: '100%', padding: '10px 5px 5px 10px' }} />
                      </div>
                    }

                    <div className='col-12 my-2'>
                      <button
                        disabled={RecHumPT!==''&&MinutosRecursocalc>=1?false:true}
                        className='btn btn-success btn-sm'
                        onClick={()=>AddresouseHuman(RecHumPT,MinutosRecursocalc, task.wo_folio, task.id_work_orders_tasks)}
                      >
                        AGREGAR RECURSO
                      </button>
                    </div>

                  </div>
                </div>
              </div>
              <div className='col-12 mt-3 text-center'>
                <button className='btn btn-danger' onClick={()=>nextView(1)}><ArrowBackIcon /></button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                {
                  ResourceList.filter(rst=>rst.id_work_orders_tasks===task.id_work_orders_tasks&&rst.source_description!=="Repuestos-Paico").length>=1&&<>
                    <button className='btn btn-danger' onClick={toggleDrawer('right', false)}>Finalizar</button> <br/>
                    <button className='btn btn-warning p-3 mt-3' onClick={()=>HandleChangeStatus(task.wo_folio)}>Enviar a revisión</button>
                  </>
                }
              </div>
            </div>

              {/* vista 2 */}
            <div className={planaState.plana_2 ? 'col-12 pb-3 plana_2-show' : 'col-12 plana_2-hidden'} id='plana_2' style={{height: "95vh", overflowY: "scroll"}}>
              {/* contenido vista 3 */}
              <ViewDrawerRegistros
                task={task}
                ModalLoadded={ModalLoadded}
                setModalLoadded={setModalLoadded}
                setTexto={setTexto}
                Reload_RH={Reload_RH}
                setReload_RH={setReload_RH}
              />

              <div className='col-12 mt-3 text-center'>
                <button className='btn btn-danger' onClick={()=>nextView(1)}><ArrowBackIcon /></button>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <button className='btn btn-danger' onClick={()=>nextView(3)}><ArrowForwardIcon /></button>
              </div>
            </div>

            </div>
            
          </div>
        </div>
      </div>
       
      </Drawer>
     
    </Fragment>
  )
  
}

export default TaskComp

